import {
  FullscreenLayer as FullscreenLayerComponent,
  type WithFocusLockProps,
  withFocusLock,
} from '@volkswagen-onehub/components-core';
import type {
  FullscreenLayerOptionsV2,
  LayerV2,
} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';
import ReactDOM from 'react-dom';

import {LayerContent} from './layer-content';

export interface FullscreenLayerProps {
  readonly layer: LayerV2<unknown, FullscreenLayerOptionsV2>;
  readonly active: boolean;
  scrollElementRef(el: HTMLDivElement): void;
}

const Layer: React.FunctionComponent<FullscreenLayerProps> = (props) => {
  const {layer, active, scrollElementRef, ...ownProps} = props;

  return (
    <FullscreenLayerComponent
      {
        ...ownProps /* Used to pass through the animation props */
      }
      active={active}
      scrollElementRef={(el: HTMLDivElement) => {
        scrollElementRef(ReactDOM.findDOMNode(el) as HTMLDivElement);
      }}
      aria-labelledby={layer.options['aria-labelledby']}
    >
      <LayerContent layer={layer} />
    </FullscreenLayerComponent>
  );
};

const FullscreenLayerWithLock = withFocusLock<FullscreenLayerProps>(Layer);
FullscreenLayerWithLock.displayName = 'FullscreenLayerWithLock';

export const FullscreenLayer: React.ElementType = (
  props: FullscreenLayerProps & WithFocusLockProps,
) => {
  return <FullscreenLayerWithLock {...props} disabled={props.layer.isClosed} />;
};
